import { FormTipping } from "../components/form/Tipping/FormTipping";
import FormSwitchWithText from "../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import FormSelectWithText from "../components/form/Tipping/FormTipingSelect";
import { options } from "../components/tipping/util/options";

const tippingForm = (selectedTipingOptions:Object , setSelectedTipingOptions:(options:any)=>void, t:(key:string)=>string,venue_group_id?:string): IDynamicFormRow[] => {
  const selectedTippingOptions = Object.values(selectedTipingOptions).filter(item=>item.enabled)
  const fixedRows = [
    {
      label: "tipping.mainTitle",
      keyName: "tipping_enabled",
      Component: FormSwitchWithText,
      formProps: {        
        secondLabel: venue_group_id ? "tipping.groupTippingEnableText" : "tipping.mainCaption",
        hasStatus: true,
      }
    },
    
  ];

  const dynamicRows = options.map((opt: any) => ({
      label: "",
      Component: FormTipping,
      keyName: `${opt.keyName}`,
      formProps:{
        setSelectedTipingOptions,
        selectedTipingOptions
      },      
      isGroupPageTipping:venue_group_id,
      ...opt
  }));

  const defaultOptionRow = {
      label: "tipping.DefaultOption",
      keyName: "default_option_id",
      Component: FormSelectWithText,
      formProps: {
        secondLabel: "tipping.DefaultOptionSubTitle",
        selectOptions: selectedTippingOptions.map(item=>{
          if(item.tip_type === "NODEFAULT"){
            return {
              name: item.name,
              value: item.id
            }
          }else if(item.tip_type === "ROUNDUP"){
            return {
              name: t('tipping.roundup'),
              value: item.id
            }
          }else if(item.tip_type === "PERCENTAGE"){
            return {
              name:item.value + "%",
              value:item.id
            }
          }
          return {
            name:t('tipping.custom'),
            value:item.id
          }
        }),
        gridColumnOptions: {
          formCol: 2,
        }
      },
  }

  return [...fixedRows, ...dynamicRows, defaultOptionRow];
};

export default tippingForm;
